import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { formatAccountNumber } from '@eika-infrastruktur/format';

import type { TransactionActor } from '../../../../generated-types';

import './PaymentDescription.scss';

interface Props {
    receiver?: TransactionActor;
}

const PaymentDescription: React.FC<Props> = ({ receiver }) => {
    if (!receiver) {
        return (
            <div>
                <Skeleton height={20} width={115} />
            </div>
        );
    }

    const description = receiver.name ?? formatAccountNumber(receiver.accountNumber) ?? receiver.iban?.value;

    return (
        <span className="payment-description__text" data-testid="transaction-receiver">
            {description}
        </span>
    );
};

export default PaymentDescription;
